import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

import { rentalReducer } from 'features/rental/reducers'
import staffReducer from 'features/staff/staffSlice'
import inboxReducer from 'features/inbox/inboxSlice'

export const store = configureStore({
  reducer: {
    rental: rentalReducer,
    staffs: staffReducer,
    inboxes: inboxReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
